import {EnvironmentType} from "@app/enums/enums";


export const environment = {
  production: false,
  apiUrl: 'https://daemaapidev.clavisco.com/',
  name: `Danoi`,
  type: EnvironmentType.Development,
  env: 'Development',
  recatchaSiteKey: '6Lf7vwssAAAAAP5OaqzbL0rBL8rvNDOqEHlHlOWL',
  LogRocketId: '',
  sentry: {
    /** DSN del proyecto en Sentry. Vacio o enabled:false desactiva el SDK por completo */
    dsn: 'https://7642f3abdbe4cf280837966e60310962@o4511328163725312.ingest.us.sentry.io/4511753010872320',
    /** Habilita el envio de errores, trazas y replays */
    enabled: false,
    /** Porcentaje de navegaciones que se envian como trazas de rendimiento */
    tracesSampleRate: 0,
    /** Porcentaje de sesiones que se graban completas */
    replaysSessionSampleRate: 0,
    /** Porcentaje de sesiones que se graban cuando ocurre un error */
    replaysOnErrorSampleRate: 1
  }
};
